/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Filter_All_SellableInputs */

const vi_product_filter_all_sellable = /** @type {(inputs: Product_Filter_All_SellableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả SP`)
};

/**

* @param {Product_Filter_All_SellableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_filter_all_sellable = /** @type {((inputs?: Product_Filter_All_SellableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Filter_All_SellableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_filter_all_sellable(inputs)
});